import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { AccessTime as AccessTimeIcon } from '@mui/icons-material';

interface InactivityWarningProps {
  open: boolean;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export default function InactivityWarning({ open, onStayLoggedIn, onLogout }: InactivityWarningProps) {
  return (
    <Dialog
      open={open}
      onClose={onStayLoggedIn}
      aria-labelledby="inactivity-dialog-title"
      PaperProps={{
        elevation: 8,
        sx: { minWidth: 400 }
      }}
    >
      <DialogTitle id="inactivity-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AccessTimeIcon color="warning" />
          <Typography variant="h6">Inactivity Warning</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          You've been inactive for 25 minutes. You will be automatically logged out in 5 minutes.
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Would you like to stay logged in?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          Log Out Now
        </Button>
        <Button onClick={onStayLoggedIn} variant="contained" autoFocus>
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
}
